/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of NormalH5EnvConfig
 */

import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import AH5EnvConfigSync from 'com/didichuxing/tracker/h5/envconfig/AH5EnvConfigSync';
import UUID from 'com/didichuxing/tracker/plugin/utils/UUID';
const OMEGA_ID: string = '_OMGID';

/**
 * H5 normal 容器。
 *
 * @class
 * @implements {IEnvConfigurationItem}
 */
export default class NormalH5EnvConfig extends AH5EnvConfigSync {

    private context: ITrackerContext | undefined;

    /**
     * @override
     * @inheritDoc
     * @param {ITrackerContext} context
     * @returns {boolean}
     */
    public validate(context: ITrackerContext): boolean {
        this.context = context;
        return true;
    }

    /**
     * 从cookie中读取omgid
     * @returns {string | undefined}
     */
    private getOmgIdFromCookie(): string | undefined {
        const items: string[] = document.cookie.split(';');
        for (let i: number = 0, j: number = items.length; i < j; ++i) {
            if (items[i].trim().indexOf(`${ OMEGA_ID }=`) === 0) {
                return items[i].split('=')[1].trim();
            }
        }
        return;
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITracker} tracker
     * @returns {Promise<void>}
     */
    public beforeDeliver(tracker: ITracker): Promise<void> {
        if (this.context) {
            let omgId: string | undefined = this.context.omgId;
            if (!omgId) {
                // cookie和local中都进行取值
                omgId = this.getOmgIdFromCookie() || this.getOidFromLocal();
            }
            if (!omgId) {
                omgId = UUID.v4;
                // 存储进行区分
                if (this.context.useLocalOid) {
                    this.saveOidToLocal(omgId);
                } else {
                    this.saveOidToCookie(omgId);
                }
            }
            Object.assign(this.context, {
                omgId: omgId
            });
        }
        return Promise.resolve();
    }

    private getOidFromLocal(): string | undefined {
        const id = localStorage.getItem(OMEGA_ID);
        if (id) {
            return id;
        }
        return undefined;
    }
    private saveOidToLocal(oid: string) {
        localStorage.setItem(OMEGA_ID, oid);
    }
    private saveOidToCookie(omgId: string) {
        const expiredDate: Date = new Date();
        expiredDate.setFullYear(expiredDate.getFullYear() + 10);
        document.cookie = `${ OMEGA_ID }=${ omgId }; expires=${ expiredDate }; path=/`;
    }
}
